import { useEffect, useRef } from 'react';
import debounce from 'hs-lodash/debounce';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { usePubSubHealthCheck } from 'conversations-internal-pub-sub/redux/hooks/usePubSubHealthCheck';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useCheckNetwork } from '../hooks/useCheckNetwork';
import PubSubErrorAlertText from './PubSubErrorAlertText';
import { jsx as _jsx } from "react/jsx-runtime";
const ALERT_DEBOUNCE_MS = 4000;
const PUBSUB_FAILED = 'PUBSUB_FAILED';
const PUBSUB_FAILED_NETWORKERROR = 'PUBSUB_FAILED_NETWORKERROR';
const PUBSUB_RESTORED = 'PUBSUB_RESTORED';
const debouncedShowError = debounce((showingErrorAlert, isNetworkConnected) => {
  const id = !isNetworkConnected ? PUBSUB_FAILED_NETWORKERROR : PUBSUB_FAILED;
  FloatingAlertStore.addAlert({
    id,
    message: /*#__PURE__*/_jsx(PubSubErrorAlertText, {
      isNetworkConnected: isNetworkConnected
    }),
    type: 'danger',
    sticky: true
  });
  showingErrorAlert.current = true;
}, ALERT_DEBOUNCE_MS);
const showReconnectedAlert = showingErrorAlert => {
  FloatingAlertStore.removeAlert(PUBSUB_FAILED);
  FloatingAlertStore.removeAlert(PUBSUB_FAILED_NETWORKERROR);
  FloatingAlertStore.addAlert({
    id: PUBSUB_RESTORED,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.banners.pubSubRestored.message"
    }),
    type: 'success'
  });
  showingErrorAlert.current = false;
};

/* eslint-disable-next-line react/display-name */
const PubSubHealthCheck = () => {
  const {
    isFailed,
    isOnline
  } = usePubSubHealthCheck();
  const isNetworkConnected = useCheckNetwork();
  const showingErrorAlert = useRef(false);
  useEffect(() => {
    if (isFailed) {
      debouncedShowError(showingErrorAlert, isNetworkConnected);
    } else if (isOnline) {
      debouncedShowError.cancel();
      if (showingErrorAlert.current) {
        showReconnectedAlert(showingErrorAlert);
      }
    }
  }, [isFailed, isOnline, showingErrorAlert, isNetworkConnected]);
  return null;
};
export default PubSubHealthCheck;